import CONSTANTS from '@/helpers/constants';
import accountAdapter from '@/adapters/account';
import chargeAdapter from '@/adapters/charge';
import selectAdapter from '@/adapters/select';
import meterAdapter from '@/adapters/meter';
import getLastMonthPeriod from '@/helpers/getChargePeriod';

export default {
  namespaced: true,
  state: {
    profile: null,
    accounts: [],
    charges: [],
    login: '',
  },
  getters: {
    isAuthenticated: ({ profile }) => Boolean(profile),
    hasAccount: ({ accounts }) => accounts.length > 0,
  },
  mutations: {
    setProfile(state, profile) {
      state.profile = profile;
    },
    setAccounts(state, accounts) {
      state.accounts = accounts;
    },
    setCharges(state, charges) {
      state.charges = charges;
    },
    setLogin(state, login) {
      state.login = login;
    },
    clearProfile(state) {
      state.profile = null;
    },
    clearAccounts(state) {
      state.accounts = [];
    },
    clearCharges(state) {
      state.charges = [];
    },
    clearLogin(state) {
      state.login = '';
    },
  },
  actions: {

    // Токен

    setToken(ctx, token) {
      localStorage.setItem(CONSTANTS.AUTH_TOKEN, token);
      return token;
    },
    fetchToken({ dispatch }, payload) {
      return this.$axios.post('/dvec/auth', payload)
        .then(({ data }) => dispatch('setToken', data.bearer));
    },

    // Авторизация/регистрация

    async signin({ commit, dispatch }, payload) {
      await dispatch('fetchToken', payload);
      await Promise.all([
        dispatch('fetchProfile'),
        dispatch('fetchProfileAccounts'),
        dispatch('fetchProfileCharges'),
      ]);
      commit('setLogin', payload.username);
      return true;
    },
    signup(ctx, payload) {
      const { login: username, email, phone } = payload;
      return this.$axios.post('/dvec/register', { username, email, phone })
        .then(({ data }) => {
          const { success } = data;
          if (success) {
            return payload;
          }
          throw new Error(data.msg);
        });
    },

    // Получение счетов/начислений

    fetchProfileAccounts({ commit }) {
      return this.$axios.get('/dvec/info')
        .then(({ data }) => {
          const [res] = data?.lc_info?.original_data || [];
          const items = res?.result || [];
          const accounts = items.map(accountAdapter);
          commit('setAccounts', accounts);
          return accounts;
        });
    },
    fetchProfileCharges({ commit }) {
      const period = getLastMonthPeriod();
      return this.$axios.post('/dvec/charge/history', period)
        .then(({ data }) => {
          const [res] = data?.history?.original_data || [];
          const items = res?.result || [];
          const charges = items.map(chargeAdapter);
          commit('setCharges', charges);
          return charges;
        });
    },

    // Профиль

    fetchProfile({ commit }) {
      const profile = { email: '', phone: '' };
      commit('setProfile', profile);
      return Promise.resolve(profile);
    },
    updateProfile({ commit }, payload) {
      return this.$axios.post('/dvec/update', payload)
        .then(({ data }) => {
          const { success } = data;
          if (success) {
            commit('setProfile', payload);
            return payload;
          }
          throw new Error(data.msg);
        });
    },

    // Регистрация/привязка лс

    fetchOrganizations() {
      return this.$axios.get('/dvec/subscr/orgs')
        .then(({ data }) => {
          const items = data?.proxied?.original_data || [];
          return items.map(selectAdapter).filter((el) => el.id && el.id >= 0);
        });
    },
    fetchCitiesByOrganizationId(ctx, id) {
      return this.$axios.get(`/dvec/subscr/orgs/${id}/city`)
        .then(({ data }) => {
          const items = data?.proxied?.original_data || [];
          return items.map(selectAdapter).filter((el) => el.id && el.id >= 0);
        });
    },
    fetchStreetsByCityId(ctx, id) {
      return this.$axios.get(`/dvec/subscr/city/${id}/street`)
        .then(({ data }) => {
          const items = data?.proxied?.original_data || [];
          return items.map(selectAdapter).filter((el) => el.id && el.id >= 0);
        });
    },
    fetchHousesByStreetId(ctx, id) {
      return this.$axios.get(`/dvec/subscr/street/${id}/house`)
        .then(({ data }) => {
          const items = data?.proxied?.original_data || [];
          return items.map(selectAdapter).filter((el) => el.id && el.id >= 0);
        });
    },
    fetchPremisesByHouseId(ctx, id) {
      return this.$axios.get(`/dvec/subscr/house/${id}/premise`)
        .then(({ data }) => {
          const items = data?.proxied?.original_data || [];
          return items.map(selectAdapter).filter((el) => el.id && el.id >= 0);
        });
    },
    fetchAccountsByPremiseId(ctx, id) {
      return this.$axios.get(`/dvec/subscr/premise/${id}/account`)
        .then(({ data }) => {
          const items = data?.proxied?.original_data || [];
          return items.map(selectAdapter).filter((el) => el.id && el.id >= 0);
        });
    },
    bindAccountById(ctx, id) {
      return this.$axios.post('/dvec/subscr', { subscr_id: id })
        .then(({ data }) => {
          const { success } = data;
          if (success) {
            return id;
          }
          throw data;
        });
    },

    // Получение/передача показаний приборов учета

    async fetchAccountsMeters({ state, dispatch }) {
      const promises = state.accounts
        .map((account) => account.code)
        .map((code) => dispatch('fetchMetersByAccountCode', code));
      const meters = await Promise.all(promises);
      return meters.flat();
    },
    fetchMetersByAccountCode(ctx, code) {
      return this.$axios.get(`/dvec/omnius/meters/${code}`)
        .then(({ data }) => {
          const item = data?.proxied?.original_data || {};
          const { Meters = [] } = item;
          // const { Success, Message, Meters = [] } = item;
          // if (!Success) {
          //   throw new Error(Message);
          // }
          return Meters.map((el) => meterAdapter({
            ...el,
            SubscrId: item.SubscrId,
            SubscrCode: code,
          }));
        });
    },
    sendMeter(ctx, meter) {
      return this.$axios.post('/dvec/omnius/meters/save', meter.getPayload())
        .then(({ data }) => {
          const item = data?.proxied?.original_data || {};
          const { Success, Message } = item;
          if (Success) {
            return meter;
          }
          throw new Error(Message);
        });
    },
    sendAllMeters({ dispatch }, meters) {
      const promises = meters
        .filter((meter) => meter.isComplete())
        .map((meter) => dispatch('sendMeter', meter));
      return Promise.all(promises);
    },

    // Чистим все

    clearAll({ commit, dispatch }) {
      dispatch('setToken', '');
      commit('clearProfile');
      commit('clearAccounts');
      commit('clearCharges');
      commit('clearLogin');
    },
  },
};
